import './preloader.css';

const Preloader = () => {
  return <div className="loader">loading</div>;
};

export default Preloader;
